import React, { useEffect, useReducer } from 'react';
import Context from './context';
import { AuthLogin } from '@/config/api.d';
import { eventBus } from '@/utils/eventBus';


type ACTIONTYPE = { type: 'setData'; data: any };

const reducer = (state: any, action: ACTIONTYPE) => {
  switch (action.type) {
    case 'setData':
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export enum PageStatus {
  ERROR = 'error',
  NOLOGIN = 'nologin',
  NORMAL = 'normal',
}

export interface AppState {
  pageStatus:  PageStatus;
  account: string;
  userInfo: AuthLogin['data'];
}

export const GlobalDataProvider = (props: any) => {
  const { children } = props;
  const initState: AppState = {
    pageStatus: (sessionStorage.getItem('videoAudit-b-pageStatus') as PageStatus) || PageStatus.NOLOGIN,
    account: localStorage.getItem('videoAudit-b-account') || '',
    userInfo: sessionStorage.getItem('videoAudit-b-userInfo') ? (JSON.parse(sessionStorage.getItem('videoAudit-b-userInfo')!)) : {},
  };

  // 初始化reducer
  const [state, dispatch] = useReducer(reducer, initState);
  const GetgeneralConfig = async () => {
  };
  const initApp = () => {
    GetgeneralConfig();
  };
  // 初始化
  useEffect(() => {
    initApp();
  }, []);

  useEffect(() => {
    // 监听用户dispatch更新事件
    const listener = (data?: any) => {
      dispatch({ type: 'setData', data });
    };
    
    eventBus.on('eventBusDispatch', listener);
    
    return () => {
      // 清理监听器
      eventBus.off('eventBusDispatch', listener);
    };
  }, [dispatch]);

  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};
